export default __webpack_public_path__ + "static/Hero-88cc27b26bb1daca039e962eb0e94934.png";